import React, { useCallback, useState } from "react";

import { MetaTags } from "src/components";
import { useUpdatePasswordMutation } from "src/graphql/generated/queries";
import { useSnackbar, useCurrentAccount, useMyLogin } from "src/hooks";
import { useBrandStore } from "src/stores/brand-store";

import { Credentials } from "./_components/Credentials";
import { ModalPassword, type UpdatePasswordInputs } from "./_components/ModalPassword";

const GENERIC_PASSWORD_ERROR_MESSAGE =
  "Une erreur est survenue lors du changement de votre mot de passe";

// TODO: delete this component when all users are migrated to Okta
const LegacyProfileCredentials = () => {
  const account = useCurrentAccount();
  const login = useMyLogin();
  const { enqueueSnackbar } = useSnackbar();
  const brandCode = useBrandStore((state) => state.brandCode);

  const [open, setOpen] = useState(false);
  const [passwordUpdateSuccess, setPasswordUpdateSuccess] = useState(false);

  const {
    mutate: updatePassworLegacydMutation,
    isLoading: isLoadingLegacyPasswordUpdate,
    reset: resetLegacyPasswordUpdate,
  } = useUpdatePasswordMutation();

  const onSubmit = useCallback(
    ({ currentPassword, newPassword }: UpdatePasswordInputs) => {
      updatePassworLegacydMutation(
        {
          request: {
            currentPassword,
            newPassword,
            confirmationPassword: newPassword,
            userId: account.customer.id,
            brandCode,
          },
        },
        {
          onSuccess: () => {
            setPasswordUpdateSuccess(true);
          },
          onError: () => {
            enqueueSnackbar(GENERIC_PASSWORD_ERROR_MESSAGE, {
              variant: "error",
            });
          },
        }
      );
    },
    [account.customer]
  );

  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    resetLegacyPasswordUpdate();
    setOpen(false);
  };

  return (
    <>
      <MetaTags title="Mon profil - Mes identifiants" />

      <Credentials login={login} handleOpen={handleOpen} />

      <ModalPassword
        loading={isLoadingLegacyPasswordUpdate}
        open={open}
        handleClose={handleClose}
        onSubmit={onSubmit}
        isSuccess={passwordUpdateSuccess}
      />
    </>
  );
};

export default LegacyProfileCredentials;
